export default global.__CLIENT_CONFIG__;
